import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';

import Button from './components/button/Button';
import ModalCalculator from './components/modal/ModalCalculator';

import './App.css';

const App = () => {
    const [open, setOpen] = useState(false);
    const [loaded, setLoaded] = useState(false);
    
    useEffect(() => {
       setTimeout(() => {
           setOpen(true);
           setLoaded(true);
       }, 700);
    }, []);
    
    const accessibility = window.location.pathname.includes("neon");
    const prod = true; // Change to false for local running
    
    return (accessibility && prod || !prod) && (
        <div className="App">
            {
                !open && loaded && <Button
                    onClick={() => setOpen(true)}
                    text='Calculate Savings'
                />
            }
            {
                ReactDOM.createPortal(
                    <ModalCalculator
                        open={open}
                        onClose={() => setOpen(false)}
                    />,
                    document.getElementById('portal'))
            }
        </div>
    );
};

export default App;
